<template>
  <section class="why-choose-us">
    <div class="container" :class="{ 'container-mobile': isMobile }" id="carRent">
      <div class="renta-car__content">
        <div class="section-title">{{ rentACar.title }}</div>
        <div class="description">
          <p v-for="(line, index) in rentACar.description" :key="index">
            {{ line }}
          </p>
        </div>
        <div class="car-categories">
          <div class="single-category" v-for="(cars, category) in rentACar.carCategories" :key="category">
            <div class="title">{{ cars[0].title }}</div>
            <div class="cars">
              <div class="car" v-for="car in cars" :key="car.id" @click="openModalCar(car.category)">
                <div class="car__icon">
                  <img class="car-img" :src="car.img" :alt="auto" loading="lazy"/>
                </div>
                <div class="car__info">
                  <div class="car-left">
                    <div class="car-title">{{ car.name }}</div>
                    <div class="car__text">
                      <p>{{ car.transmission }}</p>
                      <p>{{ car.fuel }}</p>
                      <p>{{ car.seats }} | {{ car.doors }}</p>
                      <p>{{ car.bags }}</p>
                    </div>
                  </div>
                  <div class="car-price">
                    <div class="up">{{ car.fprice }}€</div>
                    <div class="down">1-2 {{ $t('rentACar.days') }}</div>
                    <div class="up">{{ car.sprice }}€</div>
                    <div class="down">3-6 {{ $t('rentACar.days') }}</div>
                    <div class="up">{{ car.tprice }}€</div>
                    <div class="down">7+ {{ $t('rentACar.days') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn" @click="openModal">{{ $t('rentACar.title') }}</button>
        <!-- Modal -->
        <div v-if="showModal" class="modal-overlay" @click="closeModal">
          <div class="modal" @click.stop>
            <button class="close-btn" @click="closeModal">&times;</button>
            <div v-if="!submitted">
              <h2>{{ $t('rentACar.form.reservation') }}</h2>
              <form @submit.prevent="submitForm">
                <div class="row">
                  <label for="car-category">{{ $t('rentACar.form.category') }}</label>
                  <select id="car-category" v-model="formData.category" required>
                    <option value="" disabled selected hidden>{{ $t('rentACar.form.selectCategory') }}</option>
                    <option v-for="category in carCategories" :key="category" :value="category">
                      {{ $t(category) }}
                    </option>
                  </select>
                </div>
                <div class="row">
                  <label for="date">{{ $t('rentACar.form.date') }}</label>
                  <input type="date" id="date" v-model="formData.date" required/>
                </div>
                <div class="row">
                  <label for="date">{{ $t('rentACar.form.dateReturn') }}</label>
                  <input type="date" id="date" v-model="formData.dateReturn" required/>
                </div>
                <div class="row">
                  <label for="name">{{ $t('rentACar.form.name') }}</label>
                  <input type="text" id="name" v-model="formData.name" required/>
                </div>
                <div class="row">
                  <label for="email">{{ $t('rentACar.form.email') }}</label>
                  <input type="text" id="email" v-model="formData.contact" required/>
                </div>

                <button type="submit" class="submit-btn">{{ $t('rentACar.form.send') }}</button>
              </form>
            </div>
            <div v-else class="confirmation">
              <h2 v-if="!emailError">{{ $t('rentACar.form.reservationSuccess') }} </h2>
              <h2 v-else style="color: red;">{{ $t('rentACar.form.reservationFailed') }} </h2>

              <p v-if="!emailError" class="thank-you-msg">{{ $t('rentACar.form.success') }}</p>
              <p v-else class="thank-you-msg" style="color: red;">
                {{ $t('rentACar.form.tryAgain') }}
              </p>

              <br>
              <p v-if="!emailError"><strong>{{ $t('rentACar.form.category') }}</strong> {{ $t(formData.category) }}</p>
              <p v-if="!emailError"><strong>{{ $t('rentACar.form.date') }}:</strong> {{ formData.date }}</p>
              <p v-if="!emailError"><strong>{{ $t('rentACar.form.name') }}:</strong> {{ formData.name }}</p>
              <p v-if="!emailError"><strong>{{ $t('rentACar.form.contact') }}:</strong> {{ formData.email }}</p>
              <br>
            </div>
            <div v-if="isLoading" class="loader">
              <div class="spinner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: 'RentaCar',
  data() {
    return {
      isMobile: false,
      showModal: false,
      submitted: false,
      emailError: false,
      isLoading: false,
      formData: {
        name: '',
        contact: '',
        date: '',
        dateReturn: '',
        category: '',
        message: ''
      },
      carCategories: [
        "carCategories.compact", "carCategories.mid", "carCategories.full"
      ]
    }
  },
  computed: {
    rentACar() {
      return this.$i18n.getLocaleMessage(this.$i18n.locale).rentACar;
    },
  },
  mounted() {
    const cars = document.querySelectorAll(".car");

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.3, // Malo povećano da se aktivira kasnije
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          entry.target.style.transitionDelay = `${index * 0.3}s`; // Svakom autu dodajemo delay
          entry.target.classList.add("visible");
        }
      });
    }, options);

    cars.forEach((car) => observer.observe(car));
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 1159;
    },
    openModal() {
      this.showModal = true;
      this.submitted = false;
    },
    openModalCar(category) {
      this.formData.category = category;
      this.showModal = true;
    //  console.log(this.formData)
    },
    closeModal() {
      this.showModal = false;
      this.formData = {name: "", contact: "", category: "", date: ""};
    },
    submitForm: function () {
      // this.submitted = true;
      if (this.formData.category === 'carCategories.full') {
        this.formData.category = 'Rent a car - Full-sized car';
      } else if (this.formData.category === 'carCategories.mid') {
        this.formData.category = 'Rent a car - Mid-sized car';
      } else {
        this.formData.category = 'Rent a car - Compact car';
      }
      this.isLoading = true;
      this.sendEmail();
    },
    sendEmail() {
      emailjs
          .send(
              "service_f7rqc6t",
              "template_mbhipw5",
              this.formData,
              "-zEI4YqttQNgREkFa"
          )
          .then(() => {
            this.submitted = true;
            this.emailError = false;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error("Greška:", error);
            this.emailError = true;
            this.submitted = true;
            this.isLoading = false;
          });
    },
  },
  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.renta-car {
  padding: 50px 0;
  opacity: 0;

  &.animate {
    opacity: 1;

    .renta-car__text {
      animation: slideInFromLeft 2s forwards;
    }

    .renta-car__features {
      animation: slideInFromRight 2s forwards;
    }
  }

  @keyframes slideInFromLeft {
    0% {
      transform: translateX(-100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideInFromRight {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .container {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: flex-start;

  }


  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    width: 100%;
    margin-bottom: 50px;
    //text-transform: uppercase;

    .section-title {
      padding: 100px 0 20px;
      font-family: Inter, sans-serif;
      display: flex;
      align-items: center;
      text-transform: uppercase;

      font-weight: bold;
      font-size: 80px;
      color: #FFFFFF;
    }

    .description {
      font-family: Inter, sans-serif;
      font-size: 20px;
      color: #FFFFFF;
      text-align: center;
      font-weight: 300;

      p {
        line-height: 13px;
      }
    }

    .btn {
      font-family: Inter, sans-serif;
      font-size: 24px;
      font-weight: 600;
      text-transform: uppercase;
      background-color: $primary-blue;
      color: white;
      padding: 15px;
      cursor: pointer;
      max-width: 290px;
      width: 100%;
      text-align: center;
      border-radius: 15px;
      border: 1px solid $primary-blue;
      transition: transform 0.3s ease-out, background-color 1s ease;

      &:hover {
        background-color: rgba(85, 172, 173, 0.27);
        border: 1px solid $primary-blue;
      }
    }

    .car-categories {
      .single-category {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 50px;

        .title {
          font-family: Inter, sans-serif;
          font-weight: bold;
          font-size: 48px;
          color: #FFFFFF;
          text-transform: uppercase;
          padding: 30px;
        }

        .cars {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 40px;

          .car {
            transition: transform 0.3s ease-out, background-color 1s ease;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 10px;
            max-width: 350px;
            background-color: #FFFFFF;
            border-radius: 15px;
            padding: 25px;
            text-transform: uppercase;
            border: 1px solid #FFFFFF;
            cursor: pointer;

            &__icon {
              img {
                border-radius: 15px;
                max-width: 300px;
              }
            }

            &__info {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              width: 100%;
            }

            &-left {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }

            &-title {
              font-family: Inter-Semibold, sans-serif;
              font-weight: 600;
              font-size: 24px;
              line-height: 35px;
              text-transform: uppercase;
              color: #232438;
              padding-bottom: 15px;

              &:hover {
                color: white;
              }
            }

            &__text {
              text-align: left;
              gap: 20px;
              color: #9D9D9D;

              p {
                margin: 0px;
              }
            }

            &-price {
              display: flex;
              justify-content: center;
              align-items: flex-end;
              flex-direction: column;

              .up {
                text-transform: uppercase;
                color: $primary-blue;
                font-weight: bold;
                font-size: 25px;
              }

              .down {
                text-transform: lowercase;
                font-size: 15px;
                color: #9D9D9D;
                padding-bottom: 10px;
              }
            }

            &:hover {
              background-color: rgba(85, 172, 173, 0.27);
              border: 1px solid $primary-blue;
            }
          }
        }
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .car {
      opacity: 0;
      transform: translateY(50px);
      transition: opacity 1.2s ease-out, transform 1.2s ease-out;

      &.visible {
        opacity: 1;
        transform: translateY(0);
      }
    }


    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.3); /* Semi-transparent background */
      backdrop-filter: blur(5px); /* Blurred background */
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }

    /* Centered Modal Box */
    .modal {
      background-color: rgb(85 172 173 / 30%);
      //   backdrop-filter: blur(30px);
      border-radius: 15px;
      border: 1px solid #9D9D9D;
      padding: 20px;
      width: 440px;
      color: #FFFFFF;
      text-align: center;
      position: relative;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
      animation: fadeIn 0.3s ease-in-out;
    }

    form {
      display: flex;
      flex-direction: column;

      .row {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
      }
    }

    /* Close Button */
    .close-btn {
      background: none;
      border: none;
      font-size: 22px;
      position: absolute;
      right: 15px;
      top: 15px;
      cursor: pointer;
      color: #FFFFFF;
    }

    /* Form Styling */
    label {
      width: 50%;
      text-align: left;
    }

    input, textarea, select {
      // width: 100%;
      padding: 8px;
      margin: 5px 0;
      border: 1px solid #ccc;
      border-radius: 5px;
      font-size: 16px;
      width: 100%;
    }

    /* Submit Button */
    .submit-btn {
      background: $primary-blue;
      color: white;
      padding: 10px;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      width: 100%;
      transition: transform 0.3s ease-out, background-color 1s ease;
      margin-top: 15px;
    }

    .submit-btn:hover {
      background: $darker-blue;
    }

    .confirmation {
      text-align: center;
      animation: fadeIn 0.3s ease-in-out;
    }

    .confirmation p {
      font-size: 16px;
      margin: 10px 0;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: scale(0.9);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }

    .loader {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      backdrop-filter: blur(5px);
    }

    .spinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid $primary-blue;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 2s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

.container-mobile {

  .renta-car {
    padding: 30px 0 !important;
    opacity: 0;

    &.animate {
      opacity: 1;

      .renta-car__text {
        animation: slideInFromLeft 2s forwards;
      }

      .renta-car__features {
        animation: slideInFromRight 2s forwards;
      }
    }


    .container {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: flex-start;

    }


    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 30px;
      width: 100%;
      margin-bottom: 50px;

      .section-title {
        padding: 30px 0 20px !important;
        font-size: 30px !important;
      }

      .description {
        font-size: 10px !important;
        width: 100% !important;
        p {
          line-height: 20px !important;
          margin: 0;
        }
      }

      .btn {
        text-transform: uppercase;
        background-color: $primary-blue;
        color: white;
        padding: 17px 24px;
        cursor: pointer;
        font-size: 1rem;
        border-radius: 15px;
        border: 1px solid $primary-blue;
        text-align: center;
        transition: transform 0.3s ease-out, background-color 1s ease;

        &:hover {
          background-color: rgba(85, 172, 173, 0.27);
          border: 1px solid $primary-blue;
        }
      }

      .car-categories {
        .single-category {
          padding-bottom: 30px !important;

          .title {
            font-size: 30px !important;
            padding: 15px !important;
          }

          .cars {
            flex-wrap: nowrap;
            width: 100vw !important;
            gap: 5px !important;

            .car {
              border-radius: 8px !important;
              padding: 2.5px !important;

              &__icon {
                img {
                  border-radius: 10px;
                  max-width: 90px !important;
                }
              }

              &-title {
                font-size: 8px !important;
                padding-bottom: 6px !important;
                line-height: normal;
              }

              &__text {
                font-size: 6px !important;
              }

              &-price {
                .up {
                  font-size: 9px !important;
                }

                .down {
                  font-size: 5px !important;
                  padding-bottom: 6px !important;
                }

              }
            }
          }
        }
      }
      .btn {
        font-size: 13px !important;
        border-radius: 10px !important;
        padding: 12px !important;
        max-width: 200px !important;
      }
    }
  }
}


@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>
